module.exports = __webpack_public_path__ + "static/img/course04.63d4bfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course04.jpg
// module id = NVFh
// module chunks = 101